module.exports = __webpack_public_path__ + "img/status-bar-waiting.9d5121cf.svg";